<template>
  <el-dialog append-to-body :close-on-click-modal="false" width="800px" :title="page.name" :visible.sync="visible"
    :before-close="handleClose" :show-close="false">
    <div class="modal-body">
      <div class="content" v-html="page.content">

      </div>
      <div class="reservation-btn" @click="handleAgree">我已阅读并同意</div>
    </div>
  </el-dialog>
</template>

<script>
import { getPageDetail } from "@/api/page";
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'Agreement',
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    alias: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      loading: false,
      page: {}
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.getPageDetail()
      }
    }
  },
  mounted() {
    this.getPageDetail()
  },
  methods: {
    getPageDetail() {
      getPageDetail({ alias: this.alias }).then(res => {
        this.loading = false;
        this.page = res.data;
      }).catch((err) => {

      });
    },
    handleAgree() {
      this.$emit('success', true)
      this.handleClose()
    },
    // 关闭窗口
    handleClose() {
      // 更新visible参数      
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 20px;
  box-sizing: border-box;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #00B4E8;
  }

  .content {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #343A40;
    line-height: 28px;
    width: 100%;
    padding: 20px 16px;
    box-sizing: border-box;
    background: #F4F8F9;
  }

  .agreement {
    display: flex;
    align-items: center;
    column-gap: 12px;
    font-size: 14px;
    font-weight: 300;
    color: #222222;
    margin-top: 12px;
    padding-left: 16px;
    box-sizing: border-box;

    input {
      margin-top: 0;
    }

    a {
      color: #E40000;
      cursor: pointer;
    }
  }

  .reservation-btn {
    padding: 10px 50px;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    background: #00B4E8;
    border-radius: 25px;
    margin: 19px auto 0;
    width: fit-content;
    cursor: pointer;
  }
}
</style>
